import {Switch} from '@wandb/weave/components';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useMemo} from 'react';
import {toast} from 'react-toastify';

import {
  useAddPublicQueueLaunchAgentTeamConfigMutation,
  useDeletePublicQueueLaunchAgentTeamConfigMutation,
} from '../../../generated/graphql';
import {TeamBaseEntity} from '../../../graphql/teamQuery';
import {propagateErrorsContext} from '../../../util/errors';

export interface PublicQueueLaunchAgentSwitchProps {
  entity: TeamBaseEntity;
  isViewerAdmin: boolean;
  userId: string;
  refetch?: () => void;
  isFederatedIdentity?: boolean;
}

export const PublicQueueLaunchAgentSwitch: React.FC<
  PublicQueueLaunchAgentSwitchProps
> = ({refetch, entity, userId, isViewerAdmin}) => {
  const [addPublicQueueLaunchAgent] =
    useAddPublicQueueLaunchAgentTeamConfigMutation({
      context: propagateErrorsContext(),
      onCompleted: refetch,
    });

  const [deletePublicQueueLaunchAgent] =
    useDeletePublicQueueLaunchAgentTeamConfigMutation({
      context: propagateErrorsContext(),
      onCompleted: refetch,
    });

  const isMemberPublicQueueLaunchAgent = useMemo(() => {
    return (
      entity.publicQueueLaunchAgents?.some(
        (agent: {id: string}) => agent.id === userId
      ) ?? false
    );
  }, [entity.publicQueueLaunchAgents, userId]);

  return (
    <Tailwind>
      <Switch.Root
        checked={isMemberPublicQueueLaunchAgent}
        disabled={!isViewerAdmin}
        onClick={async () => {
          try {
            if (isViewerAdmin) {
              if (!isMemberPublicQueueLaunchAgent) {
                await addPublicQueueLaunchAgent({
                  variables: {
                    input: {
                      userID: userId,
                      entityName: entity.name,
                    },
                  },
                });
                refetch?.();
                toast('Added public queue launch agent.');
              } else {
                await deletePublicQueueLaunchAgent({
                  variables: {
                    input: {
                      userID: userId,
                      entityName: entity.name,
                    },
                  },
                });
                refetch?.();
                toast('Removed public queue launch agent.');
              }
            } else {
              toast(
                'Only W&B admins are allowed to manage public queue launch agents.'
              );
            }
          } catch (error) {
            console.error(error);
            toast(
              'Something went wrong while trying to manage public queue launch agent.'
            );
          }
        }}>
        <Switch.Thumb checked={isMemberPublicQueueLaunchAgent} />
      </Switch.Root>
    </Tailwind>
  );
};
